import { z } from "zod";
import { zStringDate, zStringId } from "../../utils";
import { dbRef } from "../../db-ref";
import { zUserSnippet } from "../users/user-snippet-resource";

export const TaskLinkedToCollectionList: [string, ...string[]] = [dbRef.serviceProject.collection];

export const taskBaseResource = {
  _id: zStringId(),
  title: z.string(),
  description: z.string(),
  dueAt: zStringDate(),
  completionInfo: z.object({ isComplete: z.boolean(), completedAt: zStringDate().optional() }),
  userDoc: zUserSnippet,
  subTasks: z.array(
    z.object({
      _id: zStringId(),
      title: z.string(),
      isComplete: z.boolean(),
    }),
  ),
};
